// src/pages/Profile.js
import React, { useState, useEffect } from "react";
import { auth, updateProfile } from "../firebase";

export default function Profile() {
  const [user, setUser] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      setDisplayName(currentUser?.displayName || "");
    });
    return () => unsubscribe();
  }, []);

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    try {
      await updateProfile(auth.currentUser, { displayName });
      setMessage({ type: "success", text: "Profile updated successfully!" });
      setTimeout(() => setMessage(null), 3000);
    } catch (error) {
      setMessage({ type: "error", text: error.message });
    }
  };

  return (
    <div className="profile-page">
      <h2>My Profile</h2>
      <div className="card">
        <form onSubmit={handleUpdateProfile}>
          <div className="form-cell">
            <label>Email</label>
            <input type="email" value={user?.email || ""} disabled />
          </div>
          <div className="form-cell">
            <label>Display Name</label>
            <input
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="Enter your display name"
            />
          </div>
          {message && (
            <div style={{ color: message.type === "success" ? "#15803d" : "#dc2626" }}>
              {message.text}
            </div>
          )}
          <div className="form-actions">
            <button type="submit" className="btn-primary">Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  );
}